export default [
  {
    path: '/admin/location-visitations',
    name: 'location-visitation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/location-visitation')
  },
  {
    path: '/admin/location-visitations/view-map/:commune_code/:plan_id',
    name: 'location-visitation-view-map',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/location-visitation/map.vue')
  }
]